import React from 'react'
import PropTypes from 'prop-types'
import { format } from 'date-fns'

class IntegrationDetails extends React.PureComponent {
  static propTypes = {
    createdAt: PropTypes.string.isRequired,
    createdBy: PropTypes.shape({
      displayName: PropTypes.string.isRequired,
    }).isRequired,
    applicationName: PropTypes.string.isRequired,
  }

  render() {
    return (
      <div className="shade-10 margin-bottom-large radius-normal padding-normal background-shade-50">
        Connected since {format(this.props.createdAt, 'dddd, Do MMMM')} by{' '}
        {this.props.createdBy.displayName}
      </div>
    )
  }
}

export default IntegrationDetails
